import axios from 'axios';

export default {
  fetchEmployee({
    commit,
  }, id) {
    return axios.get(`/employee/show/${id}`)
      .then((res) => {
        const hiddenFields = {
          fields: res.meta.invisibleFields,
          domain: 'employee',
        };

        commit('app/setHiddenFields', hiddenFields, {
          root: true,
        });

        return res;
      });
  },
  saveEmployee(_, employee) {
    return axios.post('/employee', employee);
  },
};
